import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';

const ManageUsers = ({product}) => {
const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [acType, setAcType] = useState(0);
  const [source, setSource] = useState('All');
         const [loading, setLoading] = useState(false);
         const [showModal, setShowModal] = useState(false);
         const [selectedUser, setSelectedUser] = useState('');
const [plans, setPlans] = useState([]);
const [selectedPlan, setSelectedPlan] = useState('');

  useEffect(() => {

    fetchUsers();
fetchPlans();
  }, []);


  const fetchPlans = async () => {
    setLoading(true);

    try {
      const response = await fetch(
              product == 'Salon Software' ?
        'https://api.dectwincam.com/sapi/get-premium-plans'
        :
        'https://api.dectwincam.com/dapi/get-premium-plans'
      );

      if (response.ok) {
        const data = await response.json();
        setPlans(data);
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };



    const fetchUsers = async () => {
      setLoading(true);

      try {
        const response = await fetch(
            product == 'Salon Software' ?
        'https://api.dectwincam.com/sapi/get-all-users'
        :
          'https://api.dectwincam.com/dapi/get-all-users');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();

        setUsers(data);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching users:', error);
      }
    };


const filteredUsers = users.filter((user) => {
  const matchesSearch =
    (user.business_name || '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase()) ||
    (user.mobile || '')
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

  const matchesStatus =
    acType === 2
      ? true
      : Number(user.on_or_off) == acType;


      
  const matchesSource =
    source == 'All'
      ? true
      : user.source == source;

  return matchesSearch && matchesStatus && matchesSource;
});
  

const resetWhatsappLimit = async (userId) => {
  const toastId = toast.loading('Resetting WhatsApp limit...');

  try {
    const response = await fetch(
                  product == 'Salon Software' ?
      `https://api.dectwincam.com/sapi/reset-limit/${userId}`
        :
      `https://api.dectwincam.com/dapi/reset-limit/${userId}`,
      {
        method: 'PUT',
      }
    );

    const data = await response.json();

    if (response.ok) {
      toast.success('WhatsApp limit reset successfully', {
        id: toastId,
      });

      setSelectedUser((prev) => ({
        ...prev,
        whatsapp: 0,
      }));
    } else {
      toast.error(data.message || 'Failed to reset limit', {
        id: toastId,
      });
    }
  } catch (error) {
    console.error(error);

    toast.error('Something went wrong', {
      id: toastId,
    });
  }
};



const accountStatus = async (userId, on_or_off) => {
  const toastId = toast.loading('Updating account status...');

  try {
    const response = await fetch(
       product == 'Salon Software' ?
      `https://api.dectwincam.com/sapi/admin-update-status/${userId}`
        :
      `https://api.dectwincam.com/dapi/admin-update-status/${userId}`,
      {
        method: 'PUT',
            headers: {
  'Content-Type': 'application/json',
},
        body: JSON.stringify({
          on_or_off: on_or_off,
        })
      }
    );

    const data = await response.json();

    if (response.ok) {
      toast.success('Account status updated', {
        id: toastId,
      });

      fetchUsers();
      setShowModal(false);
    } else {
      toast.error(data.message || 'Failed to update status', {
        id: toastId,
      });
    }
  } catch (error) {
    console.error(error);

    toast.error('Something went wrong', {
      id: toastId,
    });
  }
};


const renewPlan = async (userId) => {
  const toastId = toast.loading('Renewing premium plan...');

  try {
    const response = await fetch(
        product == 'Salon Software' ?
      `https://api.dectwincam.com/sapi/admin-renew-plan/${userId}`        :
      `https://api.dectwincam.com/dapi/admin-renew-plan/${userId}`,
      {
        method: 'PUT',
       
      }
    );

    const data = await response.json();

    if (response.ok) {
      toast.success('Plan renewed successfully', {
        id: toastId,
      });

      fetchUsers();
      setShowModal(false);
    } else {
      toast.error(data.message || 'Failed to renew plan', {
        id: toastId,
      });
    }
  } catch (error) {
    console.error(error);

    toast.error('Something went wrong', {
      id: toastId,
    });
  }
};


const makePremium = async (userId, plan) => {
  const toastId = toast.loading('Activating premium plan...');
   const now = new Date();
     const formatDate = (date) => {
    
      const pad = (n) => n.toString().padStart(2, '0');

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
      );
    };

    const start_date = formatDate(now);

    const yearsToAdd = parseInt(selectedPlan, 10);

    const endDate = new Date(now);
    endDate.setFullYear(endDate.getFullYear() + yearsToAdd);

    const end_date = formatDate(endDate);



  try {
    const response = await fetch(
              product == 'Salon Software' ?
      `https://api.dectwincam.com/sapi/admin-activate-plan/${userId}`
      :      `https://api.dectwincam.com/dapi/admin-activate-plan/${userId}`,
      {
        method: 'PUT',
        headers: {
  'Content-Type': 'application/json',
},
        body: JSON.stringify({
          plan: plan,
          start_date: start_date, 
          end_date: end_date
        })
      }
    );

    const data = await response.json();

    if (response.ok) {
      toast.success('Plan Activated successfully', {
        id: toastId,
      });

      fetchUsers();
      setShowModal(false);
    } else {
      toast.error(data.message || 'Failed to activate plan', {
        id: toastId,
      });
    }
  } catch (error) {
    toast.error('Something went wrong', {
      id: toastId,
    });
  }
};



  return (
    <>
      <section>

{!showModal && 
                <div className='container-fluid'>
                            <p className='sec-heading'>Manage Users</p>

<div className='d-md-flex d-sm-flex justify-content-between'>
<div className='d-flex bg-white rounded-4 mb-2 col-md-4'>
<i class="fa-solid fa-magnifying-glass text-darkblue py-3 px-3"></i>
                    <input
                    type="text"
                    className="support-input outline-0 border-0 rounded-end-4"
                    placeholder="Search User"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  </div>

             <select
  className="support-input border-0 outline-0 rounded-4 mb-2 col-md-2 col-sm-4 col-6"
  value={acType}
  onChange={(e) => setAcType(Number(e.target.value))}
>
  <option value={2}>All Account</option>
  <option value={0}>Active</option>
  <option value={1}>Inactive</option>
</select>

             <select
  className="support-input border-0 outline-0 rounded-4 mb-2 col-md-2 col-sm-4 col-6"
  value={source}
  onChange={(e) => setSource(e.target.value)}
>
  <option value='All'>All Source</option>  
  <option value='Microsoft Store'>Microsoft Store</option>
  <option value='Play Store'>Play Store</option>
  <option value='Dealer'>Dealer</option>
  <option value='Self'>Self</option>
</select>

</div>


<div className='table-responsive bg-white rounded-4 mt-3'>
    <table className='w-100'>
<tr>
    <th className='p-2'>S No</th>
    <th className='p-2'>Name</th>
    <th className='p-2'>Mobile No</th>
    <th className='p-2'>Password</th>
    <th className='p-2'>Created On</th>
        <th className='p-2'>Plan Expiry</th>

    <th className='p-2'>Activity</th>
    </tr>

                            {filteredUsers.length > 0 ? (
              filteredUsers.map((myUser, index) => (
                <tr className='text-muted para-text fw-semibold' key={myUser.id} style={{ backgroundColor: index % 2 === 0 ? 'var(--grey2)' : 'white' }}>
                      <td className='p-2'>{index + 1}</td>
                      <td className='p-2'><span className={`px-2 py-1 ${myUser.on_or_off == 1 && 'bg-danger text-white rounded-3'}`}>{myUser.business_name || 'NA'}</span></td>
                      <td className='p-2'>{myUser.mobile || 'NA'}</td>
                      <td className='p-2'>{myUser.pass || 'NA'}</td>
<td className='p-2'>
  {myUser.register
    ? new Date(myUser.register).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
    : 'NA'}
</td>          

<td className='p-2'>
  {myUser.has_premium == 1
    ? new Date(myUser.end_date).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
    : 'NA'}
</td>          
            <td className='p-2 text-center fs-5 cursor-pointer' onClick={() => {setSelectedUser(myUser); setShowModal(true)}}><i class="fa-solid fa-pen-to-square"></i></td>
                      
                </tr>
              ))
            )

            : (
              <>
                <tr className='text-center'>
                  <td colSpan='7'>
                  {/* <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' /> */}
                  <p className='fw-semibold py-4'>{loading ? 'Loading...': 'No Installation found.'}
</p>
                  </td>
                </tr>
              </>
            )}
    </table>
</div>


</div>
}

{showModal && 
<div className='container-fluid my-2'>

<div className='bg-white p-3 rounded-4'>


<div className='d-flex justify-content-between'>
                              <p className='sec-heading fs-5 my-0 text-capitalize'>{selectedUser.business_name ?? 'User'}
                                   <button className={`btn btn-sm w-auto ms-2 mb-2 ${selectedUser.on_or_off == 1 ? 'btn-danger' : 'btn-success'}`}
   onClick={async () => {


          const result = await Swal.fire({
            title: `${selectedUser.on_or_off == 1 ? 'Active' : 'Inactive'} Account?`,
            text: `${selectedUser.on_or_off == 1 ? 'This account will get activated' : `User will lose access to the account & Software will not work`}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: `Yes, ${selectedUser.on_or_off == 1 ? 'Active' : 'Inactive'}`,
          });

          if (result.isConfirmed) {
            accountStatus(
              selectedUser.client_id,
               !selectedUser.on_or_off
            );
          }
        }}>Account {selectedUser.on_or_off == 1 ? 'Inactive' : 'Active'}</button> 
                              </p>
<button className='btn btn-primary' onClick={() => {setSelectedUser(''); setShowModal(false)}}>Go back</button></div>
                               <span className='para-text fw-light'>Mobile No: {selectedUser.mobile}<br />Email: {selectedUser.email ?? 'NA'}</span>



</div>
{/* flex ends */}
  <div className="row bg-white rounded-4 mt-3 p-2 m-0">

  {selectedUser.image != null &&
      <div className="col-md-12 mb-3 text-center">
  
  <img src={`https://api.dectwincam.com/${product == 'Salon Software' ? 'sUploads' : 'dUploads'}/${selectedUser.image}`} className='rounded-4' style={{height: '6em', width: '6em'}} />
  </div>}
 
 <div className="col-md-6 mb-2">
        <strong>Category:</strong> {selectedUser.category || 'NA'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>Type:</strong> {selectedUser.type || 'NA'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>GST:</strong> {selectedUser.gst || 'NA'}
      </div>


      <div className="col-md-6 mb-2">
        <strong>Acc Created:</strong>{' '}
        {selectedUser.register
          ? new Date(selectedUser.register).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
          : 'NA'}
      </div>
<hr className='my-3' />
      <div className="col-md-12 mb-2">
        <strong>Address:</strong> {selectedUser.address || 'NA'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>State:</strong> {selectedUser.state || 'NA'}
      </div>

      <div className="col-md-6 mb-2">
        <strong>Pincode:</strong> {selectedUser.pin || 'NA'}
      </div>

<hr className='my-3' />

      <div className="col-md-12 mb-2">
        <strong>Download Source:</strong> {selectedUser.source || 'NA'}
      </div>

      <div className="col-md-12 mb-2">
        <strong>Business Description:</strong> {selectedUser.description || 'NA'}
      </div>


      <div className="col-md-6 mb-2">
        <strong>WhatsApp Limit:</strong> {selectedUser.whatsapp || '0'}/100 <button
  className='ms-2 btn btn-sm btn-danger'
  onClick={async () => {
    const result = await Swal.fire({
      title: 'Reset WhatsApp Limit?',
      text: `This will reset ${selectedUser.business_name}'s WhatsApp usage.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Reset',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      resetWhatsappLimit(selectedUser.client_id);
    }
  }}
>
  Reset Now
</button>
      </div>

<hr className='my-3' />
{selectedUser.has_premium == 0 && (
<div className="col-md-6 mb-2">
        <strong className='text-danger'>Non Premium Account</strong>



      <select
        className="form-select w-auto my-2"
        value={selectedPlan}
        onChange={(e) => setSelectedPlan(e.target.value)}
      >
        <option value="">Select Plan</option>

        {plans.map((plan) => (
          <option
            key={plan.id}
            value={plan.plan_type}
          >
            {plan.plan_name}
          </option>
        ))}
      </select>
<button className='btn btn-sm btn-warning'
   onClick={async () => {
          if (!selectedPlan) {
            toast.error('Please select a plan');
            return;
          }

          const result = await Swal.fire({
            title: 'Make Premium?',
            text: `Activate ${selectedPlan} Year plan for ${selectedUser.business_name}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#f0ad4e',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, Activate',
          });

          if (result.isConfirmed) {
            makePremium(
              selectedUser.client_id,
              selectedPlan
            );
          }
        }}>Make Premium Now</button>   

   </div>

)}

{selectedUser.has_premium == 1 && (
  <>
  <p className='my-0 fw-semibold'>Active: {selectedUser.plan} Year Plan</p>
  <div className='row'>
  <div className="col-md-6 mb-2">
        <strong>Premium Start On:</strong>{' '}
        {selectedUser.start_date
          ? new Date(selectedUser.start_date).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
          : 'NA'}
      </div>

       <div className="col-md-6 mb-2">
        <strong>Premium End On:</strong>{' '}
        {selectedUser.end_date
          ? new Date(selectedUser.end_date).toLocaleString('en-IN', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
          : 'NA'}
      </div>

<div className='col-12 mb-2'>
      <button
  className='btn btn-sm btn-warning w-auto'
  onClick={async () => {
    const result = await Swal.fire({
      title: 'Renew Premium Plan?',
      text: `Renew premium subscription for ${selectedUser.business_name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#f0ad4e',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, Renew',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      renewPlan(selectedUser.client_id);
    }
  }}
>
  Renew Current Plan
</button>
</div>


  <div className='col-md-2 mb-2'>
    <select
        className="form-select"
        value={selectedPlan}
        onChange={(e) => setSelectedPlan(e.target.value)}
      >
        <option value="">Select Plan</option>

        {plans.map((plan) => (
          <option
            key={plan.id}
            value={plan.plan_type}
          >
            {plan.plan_name}
          </option>
        ))}
      </select>
      </div>

      <button className='btn btn-sm btn-warning w-auto mb-2'
   onClick={async () => {
          if (!selectedPlan) {
            toast.error('Please select a plan');
            return;
          }

          const result = await Swal.fire({
            title: 'Make Premium?',
            text: `Activate ${selectedPlan} Year plan for ${selectedUser.business_name}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#f0ad4e',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, Activate',
          });

          if (result.isConfirmed) {
            makePremium(
              selectedUser.client_id,
              selectedPlan
            );
          }
        }}>Change Plan</button>   
</div>


  </>
)}

</div>

</div>
}


</section>
    
    </>
  )
}

export default ManageUsers